/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { FicheControleDto } from '../models/fiche-controle-dto';
import { FicheControleTypeDto } from '../models/fiche-controle-type-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des fiches de contrôles
 */
@Injectable({
  providedIn: 'root',
})
export class FichesControlesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation ficheControleGetList
   */
  static readonly FicheControleGetListPath = '/api/fiches-controles/list';

  /**
   * Renvoie la liste des fiches de contrôles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  ficheControleGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<FicheControleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControleGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FicheControleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des fiches de contrôles.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ficheControleGetList(params?: {
  }): Observable<Array<FicheControleDto>> {

    return this.ficheControleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FicheControleDto>>) => r.body as Array<FicheControleDto>)
    );
  }

  /**
   * Path part for operation ficheControleLoadList
   */
  static readonly FicheControleLoadListPath = '/api/fiches-controles/load-list';

  /**
   * Renvoie la liste des fiches de contrôles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControleLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControleLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des fiches de contrôles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControleLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.ficheControleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation ficheControleGet
   */
  static readonly FicheControleGetPath = '/api/fiches-controles/{id}';

  /**
   * Renvoie la fiche de contrôle spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  ficheControleGet$Response(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    id: number;
  }): Observable<StrictHttpResponse<FicheControleDto>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControleGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FicheControleDto>;
      })
    );
  }

  /**
   * Renvoie la fiche de contrôle spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ficheControleGet(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    id: number;
  }): Observable<FicheControleDto> {

    return this.ficheControleGet$Response(params).pipe(
      map((r: StrictHttpResponse<FicheControleDto>) => r.body as FicheControleDto)
    );
  }

  /**
   * Path part for operation ficheControlePut
   */
  static readonly FicheControlePutPath = '/api/fiches-controles/{id}';

  /**
   * Met à jour la fiche de contrôle spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControlePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControlePut$Response(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    id: number;

    /**
     * Fiche de contrôle
     */
    body: FicheControleDto
  }): Observable<StrictHttpResponse<FicheControleDto>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControlePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FicheControleDto>;
      })
    );
  }

  /**
   * Met à jour la fiche de contrôle spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControlePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControlePut(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    id: number;

    /**
     * Fiche de contrôle
     */
    body: FicheControleDto
  }): Observable<FicheControleDto> {

    return this.ficheControlePut$Response(params).pipe(
      map((r: StrictHttpResponse<FicheControleDto>) => r.body as FicheControleDto)
    );
  }

  /**
   * Path part for operation ficheControleDelete
   */
  static readonly FicheControleDeletePath = '/api/fiches-controles/{id}';

  /**
   * Supprime la fiche de contrôle spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  ficheControleDelete$Response(params: {

    /**
     * Identifiant de la fiche de contrôle à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la fiche de contrôle spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ficheControleDelete(params: {

    /**
     * Identifiant de la fiche de contrôle à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.ficheControleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation ficheControlePost
   */
  static readonly FicheControlePostPath = '/api/fiches-controles';

  /**
   * Crée la fiche de contrôle spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControlePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControlePost$Response(params: {

    /**
     * Fiche de contrôle
     */
    body: FicheControleDto
  }): Observable<StrictHttpResponse<FicheControleDto>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControlePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FicheControleDto>;
      })
    );
  }

  /**
   * Crée la fiche de contrôle spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControlePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControlePost(params: {

    /**
     * Fiche de contrôle
     */
    body: FicheControleDto
  }): Observable<FicheControleDto> {

    return this.ficheControlePost$Response(params).pipe(
      map((r: StrictHttpResponse<FicheControleDto>) => r.body as FicheControleDto)
    );
  }

  /**
   * Path part for operation ficheControleGetType
   */
  static readonly FicheControleGetTypePath = '/api/fiches-controles/type/{ficheControleId}/{id}';

  /**
   * Renvoie le type de contrôle de la fiche de contrôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControleGetType()` instead.
   *
   * This method doesn't expect any request body.
   */
  ficheControleGetType$Response(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    ficheControleId: number;

    /**
     * Identifiant du type de contrôle de la fiche de contrôle à mettre à jour
     */
    id: number;
  }): Observable<StrictHttpResponse<FicheControleTypeDto>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControleGetTypePath, 'get');
    if (params) {
      rb.path('ficheControleId', params.ficheControleId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FicheControleTypeDto>;
      })
    );
  }

  /**
   * Renvoie le type de contrôle de la fiche de contrôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControleGetType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ficheControleGetType(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    ficheControleId: number;

    /**
     * Identifiant du type de contrôle de la fiche de contrôle à mettre à jour
     */
    id: number;
  }): Observable<FicheControleTypeDto> {

    return this.ficheControleGetType$Response(params).pipe(
      map((r: StrictHttpResponse<FicheControleTypeDto>) => r.body as FicheControleTypeDto)
    );
  }

  /**
   * Path part for operation ficheControlePutType
   */
  static readonly FicheControlePutTypePath = '/api/fiches-controles/type/{ficheControleId}/{id}';

  /**
   * Met à jour le type de contrôle de la fiche de contrôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControlePutType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControlePutType$Response(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    ficheControleId: number;

    /**
     * Identifiant du type de contrôle de la fiche de contrôle à mettre à jour
     */
    id: number;

    /**
     * Type de contrôle de la fiche de contrôle
     */
    body: FicheControleTypeDto
  }): Observable<StrictHttpResponse<FicheControleTypeDto>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControlePutTypePath, 'put');
    if (params) {
      rb.path('ficheControleId', params.ficheControleId, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FicheControleTypeDto>;
      })
    );
  }

  /**
   * Met à jour le type de contrôle de la fiche de contrôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControlePutType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControlePutType(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    ficheControleId: number;

    /**
     * Identifiant du type de contrôle de la fiche de contrôle à mettre à jour
     */
    id: number;

    /**
     * Type de contrôle de la fiche de contrôle
     */
    body: FicheControleTypeDto
  }): Observable<FicheControleTypeDto> {

    return this.ficheControlePutType$Response(params).pipe(
      map((r: StrictHttpResponse<FicheControleTypeDto>) => r.body as FicheControleTypeDto)
    );
  }

  /**
   * Path part for operation ficheControleLoadListType
   */
  static readonly FicheControleLoadListTypePath = '/api/fiches-controles/type/load-list/{ficheControleId}';

  /**
   * Renvoie la liste des types de la fiche de contrôle spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ficheControleLoadListType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControleLoadListType$Response(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    ficheControleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, FichesControlesService.FicheControleLoadListTypePath, 'post');
    if (params) {
      rb.path('ficheControleId', params.ficheControleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types de la fiche de contrôle spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ficheControleLoadListType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ficheControleLoadListType(params: {

    /**
     * Identifiant de la fiche de contrôle
     */
    ficheControleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.ficheControleLoadListType$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

}
